<p-toast key="notification" position="top-right"></p-toast>

<div class="log-channels-page"
     [class.mode-both]="displayMode === 'both'"
     [class.mode-log]="displayMode === 'log'"
     [class.mode-map]="displayMode === 'map'">
  <header class="page-header">
    <button
      type="button"
      class="back-button"
      (click)="goBack()"
      [pTooltip]="'log.channels.btnBack' | transloco"
      tooltipPosition="bottom"
    >
      <i class="pi pi-arrow-left"></i>
    </button>

    <div class="page-header-title-block">
      <span class="page-header-eyebrow">{{ 'log.channels.eyebrow' | transloco }}</span>
      <h1 class="page-header-title">
        {{ (isMapOnly ? 'log.channels.titleMapOnly' : 'log.channels.title') | transloco }}
      </h1>
    </div>

    <div class="page-header-stats" *ngIf="hasData && !loading && !error">
      <span class="stat-chip">
        <i class="pi pi-th-large"></i>
        <span class="stat-label">{{ 'log.channels.metaRows' | transloco }}</span>
        <span class="stat-value">{{ rows }}</span>
      </span>
      <span class="stat-chip" *ngIf="selectedChannels.length > 0">
        <i class="pi pi-chart-line"></i>
        <span class="stat-label">{{ 'log.channels.metaChannels' | transloco }}</span>
        <span class="stat-value">{{ selectedChannels.length }}/{{ maxChannels }}</span>
      </span>

      <p-selectButton
        [options]="displayModeOptions"
        [(ngModel)]="displayMode"
        (onChange)="onDisplayModeChange()"
        [allowEmpty]="false"
        optionLabel="label"
        optionValue="value"
        styleClass="display-mode-select"
      >
        <ng-template let-item pTemplate>
          <i [class]="item.icon"></i>
          <span class="display-mode-select__lbl">{{ item.label }}</span>
        </ng-template>
      </p-selectButton>
    </div>
  </header>

  <div class="log-channels-layout">
    <aside class="sidebar">
      <div class="sidebar-header">
        <span class="counter" [class.is-full]="selectionFull">
          {{ selectedChannels.length }}/{{ maxChannels }}
        </span>
        <button
          type="button"
          class="clear-btn"
          *ngIf="selectedChannels.length > 0"
          (click)="clearSelection()"
        >
          {{ 'log.channels.btnClear' | transloco }}
        </button>
      </div>

      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
        <input
          pInputText
          type="text"
          [(ngModel)]="filterText"
          [placeholder]="'log.channels.searchPlaceholder' | transloco"
        />
      </p-iconField>

      <div class="channel-list" role="listbox" aria-multiselectable="true">
        <label
          *ngFor="let channel of filteredChannels; trackBy: trackByName"
          class="channel-item"
          [class.is-selected]="isSelected(channel)"
          [class.is-disabled]="isDisabled(channel)"
          [class.is-zeroed]="isZeroed(channel)"
          [style.--ch-accent]="colorFor(channel)"
        >
          <p-checkbox
            [binary]="true"
            [ngModel]="isSelected(channel)"
            [disabled]="isDisabled(channel)"
            (onChange)="toggleChannel(channel)"
          ></p-checkbox>
          <span
            class="channel-swatch"
            *ngIf="isSelected(channel)"
            [style.background]="colorFor(channel)"
          ></span>
          <span class="channel-name" [pTooltip]="labelFor(channel)" tooltipPosition="right">
            {{ labelFor(channel) }}
          </span>
          <i
            class="pi pi-minus-circle channel-zeroed"
            *ngIf="isZeroed(channel)"
            [pTooltip]="'log.channels.zeroedHint' | transloco"
            [attr.aria-label]="'log.channels.zeroedHint' | transloco"
            role="img"
            tooltipPosition="right"
          ></i>
        </label>
        <div *ngIf="catalogLoading" class="empty-search">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <div *ngIf="!catalogLoading && filteredChannels.length === 0" class="empty-search">
          {{ 'log.channels.noChannelsFound' | transloco }}
        </div>
      </div>

      <div class="selected-section" *ngIf="selectedChannels.length > 0">
        <div class="selected-section-title">
          {{ 'log.channels.colorsTitle' | transloco }}
        </div>
        <div class="selected-list" cdkDropList (cdkDropListDropped)="reorderChannels($event)">
          <div
            class="selected-row"
            *ngFor="let channel of selectedChannels; trackBy: trackByName"
            cdkDrag
            cdkDragPreviewContainer="parent"
            cdkDragLockAxis="y"
            [cdkDragData]="channel"
            [class.is-hidden]="!isVisible(channel)"
            [style.--ch-accent]="colorFor(channel)"
            (contextmenu)="onChannelRowContextMenu($event, channel)"
          >
            <span class="drag-handle" cdkDragHandle
              [pTooltip]="'log.channels.reorderTooltip' | transloco" tooltipPosition="top">
              <i class="pi pi-bars"></i>
            </span>
            <p-colorPicker
              [ngModel]="colorFor(channel)"
              (ngModelChange)="onColorChange(channel, $event)"
              appendTo="body"
              [pTooltip]="'log.channels.colorTooltip' | transloco"
            ></p-colorPicker>
            <span class="selected-name" [pTooltip]="labelFor(channel)" tooltipPosition="top">
              {{ labelFor(channel) }}
            </span>
            <span class="selected-unit" *ngIf="unitLabelFor(channel) as unit">{{ unit }}</span>
            <button
              type="button"
              class="row-btn settings-btn"
              (click)="openChannelSettings(channel)"
              [pTooltip]="'log.channels.channelSettings' | transloco"
              tooltipPosition="top"
            >
              <i class="pi pi-cog"></i>
            </button>
            <button
              type="button"
              class="row-btn visibility-btn"
              [class.is-off]="!isVisible(channel)"
              (click)="toggleVisibility(channel)"
              [pTooltip]="(isVisible(channel) ? 'log.channels.hideOnChart' : 'log.channels.showOnChart') | transloco"
              tooltipPosition="top"
            >
              <i [class]="isVisible(channel) ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
            </button>
            <button
              type="button"
              class="row-btn remove-btn"
              (click)="toggleChannel(channel)"
              [pTooltip]="'log.channels.removeChannel' | transloco"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="decimals-btn"
        *ngIf="selectedChannels.length > 0"
        (click)="openDecimalsDialog()"
        [pTooltip]="'log.channels.configTooltip' | transloco"
      >
        <i class="pi pi-sliders-h"></i>
        <span>{{ 'log.channels.btnConfig' | transloco }}</span>
      </button>

      <button
        type="button"
        class="visualize-btn"
        [disabled]="selectedChannels.length === 0 || loading"
        (click)="plot(true)"
      >
        <i class="pi pi-chart-line"></i>
        <span>{{ 'log.channels.btnVisualize' | transloco }}</span>
      </button>
    </aside>

    <main class="chart-area">
      <div *ngIf="loading" class="state-overlay">
        <p-progressSpinner [style]="{ width: '48px', height: '48px' }" strokeWidth="4"></p-progressSpinner>
        <p class="state-text">{{ 'log.channels.loadingFirstTime' | transloco }}</p>
      </div>

      <div *ngIf="!loading && error" class="state-overlay">
        <i class="pi pi-exclamation-triangle state-icon"></i>
        <p class="state-text">{{ error }}</p>
      </div>

      <div *ngIf="!loading && !error && !hasData" class="state-overlay">
        <i class="pi pi-chart-line state-icon"></i>
        <p class="state-text">
          {{ (catalogEmpty ? 'log.channels.noChannelsInFile' : 'log.channels.emptyState') | transloco }}
        </p>
      </div>

      <div *ngIf="hasData && !loading && !error && missing.length > 0" class="missing-banner">
        <i class="pi pi-info-circle"></i>
        <span>
          {{ 'log.channels.missingWarning' | transloco }}: {{ missingLabels }}
        </span>
      </div>

      <div class="chart-toolbar" *ngIf="hasData && !loading && !error">
        <div class="toolbar-group">
          <span class="toolbar-group-label">{{ 'log.channels.toolbar.zoom' | transloco }}</span>
          <div class="toolbar-buttons">
            <button
              type="button"
              class="toolbar-btn"
              (click)="zoomIn()"
              [pTooltip]="'log.channels.toolbar.zoomIn' | transloco"
              tooltipPosition="bottom"
            >
              <i class="pi pi-search-plus"></i>
            </button>
            <button
              type="button"
              class="toolbar-btn"
              (click)="zoomOut()"
              [pTooltip]="'log.channels.toolbar.zoomOut' | transloco"
              tooltipPosition="bottom"
            >
              <i class="pi pi-search-minus"></i>
            </button>
            <button
              type="button"
              class="toolbar-btn"
              (click)="zoomReset()"
              [pTooltip]="'log.channels.toolbar.zoomReset' | transloco"
              tooltipPosition="bottom"
            >
              <i class="pi pi-window-maximize"></i>
            </button>
          </div>
        </div>

        <div class="toolbar-divider"></div>

        <div class="toolbar-group">
          <span class="toolbar-group-label">{{ 'log.channels.toolbar.view' | transloco }}</span>
          <div class="toolbar-buttons">
            <button
              type="button"
              class="toolbar-btn"
              [class.is-active]="groupedView"
              (click)="toggleGroupedView()"
              [pTooltip]="'log.channels.toolbar.groupedView' | transloco"
              tooltipPosition="bottom"
            >
              <i class="pi pi-th-large"></i>
            </button>
            <button
              type="button"
              class="toolbar-btn"
              [class.is-active]="followCursor"
              (click)="toggleFollowCursor()"
              [pTooltip]="'log.channels.toolbar.followCursor' | transloco"
              tooltipPosition="bottom"
            >
              <i class="pi pi-directions"></i>
            </button>
          </div>
        </div>
      </div>

      <div
        #chartRef
        class="chart-container"
        [class.is-hidden]="!hasData || loading || !!error"
        (contextmenu)="onChartContextMenu($event)"
      ></div>

      <!-- Estatísticas do log: só para arquivo de log, depois que o gráfico existe,
           e escondidos no modo "Só Mapa" (mesma regra do gráfico). -->
      <app-log-stats-panel
        *ngIf="!isMapOnly && hasData && !error"
        [userID]="userID"
        [fileID]="fileID"
        [fileType]="fileType === 'ftml' ? 'ftml' : 'ftlog'"
        [channels]="statsChannels"
        [projections]="statsProjections"
      ></app-log-stats-panel>

      <!-- Mapa de injeção: dentro do chart-area pra alinhar com o gráfico do log
           (mesma largura, mesma margem) em todos os modos de visualização.
           Em .ftm/.ftmap (isMapOnly) é o único conteúdo da tela. -->
      <section class="map-section" *ngIf="showMapSection">
        <header class="map-section__header">
          <div class="map-section__title-block">
            <span class="map-section__eyebrow">Mapa de injeção</span>
            <h2 class="map-section__title" *ngIf="injectionMap">
              {{ loadAxisLabel(injectionMap.axis) }} · {{ 'injectionMap.bank' | transloco: { bank: injectionMap.bank } }}
              <small *ngIf="mapView === 'curve' && injectionMap.native_curve; else gridInfo">
                {{ 'injectionMap.nativeCurvePoints' | transloco: { count: injectionMap.native_curve.load.length } }} · {{ injectionMap.units }}
              </small>
              <ng-template #gridInfo>
                <small>{{ injectionMap.rpm.length }} × {{ injectionMap.load.length }} · {{ injectionMap.units }}</small>
              </ng-template>
            </h2>
            <p class="map-section__note" *ngIf="injectionMap?.derivation && mapView !== 'curve'">
              {{ 'injectionMap.derivedGrid' | transloco }}: {{ 'injectionMap.derivedGridNote' | transloco }}
            </p>
            <ng-container *ngIf="injectionMap?.overall_trim as trim">
              <p class="map-section__note" *ngIf="trim.percent">
                {{ 'injectionMap.overallTrim' | transloco: { percent: (trim.percent | truncNumber: '1.0-2') } }}
              </p>
            </ng-container>
            <h2 class="map-section__title" *ngIf="!injectionMap">
              {{ mapLoading ? 'Preparando o mapa…' : (mapError ?? '') }}
            </h2>
          </div>

          <div class="map-section__actions" *ngIf="!mapLoading && !mapError && injectionMap">
            <!-- Seletor de banco: só Vision com mais de um banco ativo -->
            <p-selectButton
              *ngIf="injectionMaps.length > 1"
              [options]="mapBankOptions"
              [(ngModel)]="selectedMapIndex"
              (onChange)="onBankChange()"
              [allowEmpty]="false"
              optionLabel="label"
              optionValue="value"
              styleClass="map-view-select"
            >
              <ng-template let-item pTemplate>
                <span class="map-view-select__lbl">{{ item.label }}</span>
              </ng-template>
            </p-selectButton>

            <p-selectButton
              [options]="mapViewOptions"
              [(ngModel)]="mapView"
              (onChange)="onMapViewChange()"
              [allowEmpty]="false"
              optionLabel="label"
              optionValue="value"
              styleClass="map-view-select"
            >
              <ng-template let-item pTemplate>
                <i [class]="item.icon"></i>
                <span class="map-view-select__lbl">{{ item.label }}</span>
              </ng-template>
            </p-selectButton>
          </div>
        </header>

        <div class="map-section__body">
          <div *ngIf="mapLoading" class="map-placeholder">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Preparando o mapa…</span>
            <small>Se for a primeira leitura, pode levar alguns minutos.</small>
          </div>
          <div *ngIf="!mapLoading && mapError"
               class="map-placeholder map-placeholder--error"
               [class.map-placeholder--locked]="mapPasswordProtected">
            <i class="pi" [class.pi-lock]="mapPasswordProtected" [class.pi-exclamation-triangle]="!mapPasswordProtected"></i>
            <span>{{ mapError }}</span>
            <button *ngIf="mapPasswordProtected" type="button" class="map-placeholder__action" (click)="loadMap()">
              <i class="pi pi-unlock"></i>
              {{ 'log.channels.password.enter' | transloco }}
            </button>
          </div>

          <ng-container *ngIf="!mapLoading && !mapError && injectionMap">
            <!-- Todos montados; toggle por display:none preserva o estado da câmera 3D. -->
            <div *ngIf="injectionMap.native_curve"
                 class="map-chart-wrap map-chart-wrap--curve"
                 [class.map-chart-wrap--curve-row]="!injectionMap.inverted_axis"
                 [class.is-hidden]="mapView !== 'curve'">
              <app-injection-map-2d #mapCurveRef [map]="injectionMap" [curve]="true"></app-injection-map-2d>
            </div>
            <div class="map-chart-wrap map-chart-wrap--table" [class.is-hidden]="mapView !== 'table'">
              <app-injection-map-2d #map2dRef [map]="injectionMap"></app-injection-map-2d>
            </div>
            <div class="map-chart-wrap map-chart-wrap--3d" [class.is-hidden]="mapView !== 'chart3d'">
              <app-injection-map-3d [map]="injectionMap"></app-injection-map-3d>
            </div>
          </ng-container>
        </div>
      </section>
    </main>
  </div>
</div>

<p-dialog
  [(visible)]="showDecimalsDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{ width: '600px' }"
  [breakpoints]="{ '960px': '80vw', '640px': '94vw' }"
  [header]="'log.channels.configDialogTitle' | transloco"
  styleClass="decimals-dialog"
>
  <p class="decimals-hint">{{ 'log.channels.configHint' | transloco }}</p>

  <p class="config-needs-plot" *ngIf="!canEditRanges">
    <i class="pi pi-info-circle"></i>
    <span>{{ 'log.channels.rangeNeedsPlot' | transloco }}</span>
  </p>

  <div class="config-unit" *ngIf="hasPressureSelected">
    <span class="config-unit__label">{{ 'log.channels.mapUnitLabel' | transloco }}</span>
    <p-selectButton
      [options]="mapUnitOptions"
      [(ngModel)]="mapUnit"
      (onChange)="onMapUnitChange()"
      [allowEmpty]="false"
      optionLabel="label"
      optionValue="value"
      styleClass="unit-select"
    >
      <ng-template let-item pTemplate>
        <span class="unit-select__lbl">{{ item.label }}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <p class="decimals-hint" *ngIf="hasPressureSelected">{{ 'log.channels.mapUnitHint' | transloco }}</p>

  <div class="config-table">
    <div class="config-head">
      <span></span>
      <span class="config-col-num">{{ 'log.channels.colDecimals' | transloco }}</span>
      <span class="config-col-num">{{ 'log.channels.colMin' | transloco }}</span>
      <span class="config-col-num">{{ 'log.channels.colMax' | transloco }}</span>
      <span></span>
    </div>

    <div
      class="config-row"
      *ngFor="let channel of selectedChannels; trackBy: trackByName"
      [style.--ch-accent]="colorFor(channel)"
    >
      <span class="config-name">
        <span class="decimals-swatch" [style.background]="colorFor(channel)"></span>
        <span class="config-name-lbl" [pTooltip]="labelFor(channel)" tooltipPosition="top">
          {{ labelFor(channel) }}
        </span>
        <span class="config-name-unit" *ngIf="unitLabelFor(channel) as unit">{{ unit }}</span>
      </span>
      <input
        type="number"
        class="decimals-input"
        min="0"
        [max]="maxDecimals"
        step="1"
        [ngModel]="decimalsFor(channel)"
        (ngModelChange)="setDecimals(channel, $event)"
      />
      <input
        type="number"
        class="decimals-input"
        step="any"
        [disabled]="!canEditRanges"
        [ngModel]="minFor(channel)"
        (ngModelChange)="setMin(channel, $event)"
      />
      <input
        type="number"
        class="decimals-input"
        step="any"
        [disabled]="!canEditRanges"
        [ngModel]="maxFor(channel)"
        (ngModelChange)="setMax(channel, $event)"
      />
      <button
        type="button"
        class="range-reset-btn"
        [disabled]="!hasRangeOverride(channel)"
        (click)="resetRange(channel)"
        [pTooltip]="'log.channels.resetRange' | transloco"
        tooltipPosition="left"
      >
        <i class="pi pi-refresh"></i>
      </button>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="decimals-reset-btn" (click)="resetDecimalsToDefault()">
      {{ 'log.channels.decimalsReset' | transloco }}
    </button>
    <button type="button" class="decimals-done-btn" (click)="closeDecimalsDialog()">
      {{ 'log.channels.decimalsDone' | transloco }}
    </button>
  </ng-template>
</p-dialog>

<!-- Configurações avançadas de UM canal (engrenagem / botão direito no canal) -->
<p-dialog
  [(visible)]="showChannelSettings"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{ width: '440px' }"
  [breakpoints]="{ '640px': '94vw' }"
  [header]="settingsChannel ? labelFor(settingsChannel) : ''"
  styleClass="decimals-dialog channel-settings-dialog"
>
  <ng-container *ngIf="settingsChannel as ch">
    <div class="chs-body">
      <div class="chs-row">
        <div class="chs-field">
          <label class="chs-label">{{ 'log.channels.chColor' | transloco }}</label>
          <div class="chs-color">
            <p-colorPicker
              [ngModel]="colorFor(ch)"
              (ngModelChange)="onColorChange(ch, $event)"
              appendTo="body"
            ></p-colorPicker>
            <span class="chs-color-hex">{{ colorFor(ch) }}</span>
          </div>
        </div>

        <div class="chs-field chs-field--grow">
          <label class="chs-label">{{ 'log.channels.chGroup' | transloco }}</label>
          <p-selectButton
            [options]="groupOptions"
            [ngModel]="groupFor(ch)"
            (ngModelChange)="setGroup(ch, $event)"
            [allowEmpty]="false"
            optionLabel="label"
            optionValue="value"
            styleClass="chs-group-select"
          ></p-selectButton>
        </div>
      </div>

      <div class="chs-field" *ngIf="isPressureChannel(ch)">
        <label class="chs-label">{{ 'log.channels.mapUnitLabel' | transloco }}</label>
        <p-selectButton
          [options]="mapUnitOptions"
          [(ngModel)]="mapUnit"
          (onChange)="onMapUnitChange()"
          [allowEmpty]="false"
          optionLabel="label"
          optionValue="value"
          styleClass="unit-select"
        >
          <ng-template let-item pTemplate>
            <span class="unit-select__lbl">{{ item.label }}</span>
          </ng-template>
        </p-selectButton>
      </div>

      <div class="chs-field">
        <label class="chs-label">
          <span>{{ 'log.channels.chScale' | transloco }}</span>
          <button
            *ngIf="hasRangeOverride(ch)"
            type="button"
            class="chs-reset"
            (click)="resetRange(ch)"
          >
            <i class="pi pi-refresh"></i>
            <span>{{ 'log.channels.resetRange' | transloco }}</span>
          </button>
        </label>

        <p class="chs-hint" *ngIf="!canEditRanges">
          <i class="pi pi-info-circle"></i>
          <span>{{ 'log.channels.rangeNeedsPlot' | transloco }}</span>
        </p>

        <div class="chs-minmax">
          <div class="chs-minmax__item">
            <span class="chs-sub">{{ 'log.channels.colMin' | transloco }}<ng-container *ngIf="unitLabelFor(ch) as unit"> ({{ unit }})</ng-container></span>
            <input
              type="number"
              class="decimals-input"
              step="any"
              [disabled]="!canEditRanges"
              [ngModel]="minFor(ch)"
              (ngModelChange)="setMin(ch, $event)"
            />
          </div>
          <div class="chs-minmax__item">
            <span class="chs-sub">{{ 'log.channels.colMax' | transloco }}<ng-container *ngIf="unitLabelFor(ch) as unit"> ({{ unit }})</ng-container></span>
            <input
              type="number"
              class="decimals-input"
              step="any"
              [disabled]="!canEditRanges"
              [ngModel]="maxFor(ch)"
              (ngModelChange)="setMax(ch, $event)"
            />
          </div>
          <div class="chs-minmax__item chs-minmax__item--sm">
            <span class="chs-sub">{{ 'log.channels.colDecimals' | transloco }}</span>
            <input
              type="number"
              class="decimals-input"
              min="0"
              [max]="maxDecimals"
              step="1"
              [ngModel]="decimalsFor(ch)"
              (ngModelChange)="setDecimals(ch, $event)"
            />
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template pTemplate="footer">
    <button type="button" class="decimals-done-btn" (click)="closeChannelSettings()">
      {{ 'log.channels.decimalsDone' | transloco }}
    </button>
  </ng-template>
</p-dialog>

<div
  *ngIf="contextMenuOpen"
  class="chart-context-menu"
  [style.left.px]="contextMenuX"
  [style.top.px]="contextMenuY"
  (click)="$event.stopPropagation()"
  (contextmenu)="$event.preventDefault(); $event.stopPropagation()"
>
  <button type="button" class="context-item" (click)="toggleCursorNames()">
    <i [class]="showCursorNames ? 'pi pi-check' : 'pi pi-circle'" class="context-check"></i>
    <i class="pi pi-tag context-icon"></i>
    <span>{{ 'log.channels.context.showNames' | transloco }}</span>
  </button>
  <button type="button" class="context-item" (click)="toggleCursorValues()">
    <i [class]="showCursorValues ? 'pi pi-check' : 'pi pi-circle'" class="context-check"></i>
    <i class="pi pi-hashtag context-icon"></i>
    <span>{{ 'log.channels.context.showValues' | transloco }}</span>
  </button>
  <div class="context-divider"></div>
  <button
    type="button"
    class="context-item"
    [disabled]="contextMenuChartX === null"
    (click)="positionCursor(1)"
  >
    <i class="pi pi-bookmark context-icon"></i>
    <span>{{ 'log.channels.context.placeCursor1' | transloco }}</span>
  </button>
  <button
    type="button"
    class="context-item"
    [disabled]="contextMenuChartX === null"
    (click)="positionCursor(2)"
  >
    <i class="pi pi-bookmark-fill context-icon"></i>
    <span>{{ 'log.channels.context.placeCursor2' | transloco }}</span>
  </button>
  <button type="button" class="context-item" (click)="toggleCursorsVisible()">
    <i [class]="cursorsVisible ? 'pi pi-eye' : 'pi pi-eye-slash'" class="context-icon"></i>
    <span>
      {{ (cursorsVisible ? 'log.channels.context.hideCursors' : 'log.channels.context.showCursors') | transloco }}
    </span>
  </button>
  <button
    type="button"
    class="context-item"
    *ngIf="cursor1X !== null || cursor2X !== null"
    (click)="clearCursors()"
  >
    <i class="pi pi-times context-icon"></i>
    <span>{{ 'log.channels.context.clearCursors' | transloco }}</span>
  </button>
</div>
